import {useContext, useEffect, useState} from "react";
import {Alert, Button, Card, Col, Container, Form, Image, Jumbotron, Modal, Row} from "react-bootstrap";
import {Link, useHistory, useParams} from "react-router-dom";
import Get from "../api/Get";
import {
    ADD_APPOINTMENT,
    ESPECIALITIES_ALL_BY_ACCOUNT,
    GET_SUCURSALES,
    PACIENTES_EDIT,
    SCHEDULE_DINAMIC_BY_SPECIALITY,
    CHECK_EXPEDIENTE_DUPLICADO
} from "../api/Routes";
import SelectAjax from "../components/SelectAjax";
import {authContext} from "../context/AuthContext";
import moment from 'moment'
import iconCalendar from '../img/icons/calendar.svg'
import iconRecheck from '../img/icons/recheck.svg'
import Post from "../api/Post";
import SimpleLoad from "../loader/SimpleLoad";
import {MdEdit} from "react-icons/md";
import {withTranslation} from "react-i18next";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import useCompanyType from "../hook/useCompanyType";
import * as Yup from 'yup';
import {Field, Formik} from "formik";
import {getSource} from "../utils/getSource";
import {groupBy} from '../utils/groupBy'
import CardHorarioDoctorManual from "../components/doctor/CardHorarioDoctorManual";
import Select from 'react-select';
import {isDoctor} from "../utils/isDoctor";
import {isConsultorio} from "../utils/isConsultorio";
import {URL_API} from "../constants/urls";

function CreateAppointment({t}) {
    const {id} = useParams()
    const {auth} = useContext(authContext)
    const [patient, setPatient] = useState(null)
    const [especialidad, setEspecialidad] = useState(null)
    const [loadingHorarios, setLoadingHorarios] = useState(false)
    const [doctor, setDoctor] = useState(null)
    const history = useHistory()
    const [loadingAddCita, setLoadingAddCita] = useState(false)
    const [error, setError] = useState(false)
    const [specialityOpt, setSpecialityOpt] = useState([])
    const [peso, setPeso] = useState('')
    const [talla, setTalla] = useState('')
    const [sintomas, setSintomas] = useState('')
    const [validAutomatic, setValidAutomatic] = useState(true)
    const [expediente, setExpediente] = useState('')
    const company = useCompanyType()
    const [doctoresOptDef, setDoctoresOptDef] = useState([])
    const [fecha, setFecha] = useState(new Date())
    const [horario, setHorario] = useState(null)
    const [indexSelectHor, setIndexSelectHor] = useState(null)
    const [startDay, setStartDay] = useState(0)
    const days = 7
    const source = getSource('manual')
    const [arrGroupBySchedules, setGroupBySchedules] = useState([])
    const [showDoctor, serShowDoctor] = useState(false)
    const [errorPesos, setErrorPesos] = useState(false)
    const [schedule, setSchedule] = useState(null)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
        history.replace("/admin")
    }

    const [sucursalesOpt, setSucursalesOpt] = useState([])
    const [sucursal, setSucursal] = useState("")

    // Expediente duplication check states (only for Colombia)
    const [expedienteDuplicado, setExpedienteDuplicado] = useState(false)
    const [checkingExpediente, setCheckingExpediente] = useState(false)
    const [showModalExpedienteDuplicado, setShowModalExpedienteDuplicado] = useState(false)

    // const [modalidades, setModalidades] = useState([]);
    // const [selectedModalidades, setSelectedModalidades] = useState('');


    useEffect(() => {
        Get({url: `${PACIENTES_EDIT}/${id}`, access_token: auth.data.access_token})
            .then(response => {
                //console.log(response)
                setPatient(response.data)
                setValidAutomatic(response.data.account ? response.data.account.automaticValidation : true)

                ////espcialidaesdes por defaul
                Get({
                    url: `${ESPECIALITIES_ALL_BY_ACCOUNT}/${response.data.account.id}`,
                    access_token: auth.data.access_token
                })
                    .then(response => {
                        //console.log(response)
                        setSpecialityOpt(response.data.data.response.map(el => {
                            return {
                                value: el.id,
                                label: el.name
                            }
                        }))
                    })
                    .catch(err => {
                        setShowModalServer(true)
                        if (error.response) {
                            setErrorServer(error.response)
                        }
                    })
            })
            .catch(error => {
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
    }, [])

    useEffect(() => {
        if (especialidad) {
            setEspecialidad(especialidad)
            setLoadingHorarios(true)
            setDoctor(null)
            serShowDoctor(false)
            setIndexSelectHor(null)
            //nuevo servicio buscamos los horarios y doctores por especialidad
            let url = `${SCHEDULE_DINAMIC_BY_SPECIALITY}?specialityId=${especialidad.value}&dateIni=${moment(fecha).format("DD-MM-YYYY")}&dateEnd=${moment(fecha).format("DD-MM-YYYY")}&accountId=${patient.account.id}`
            Post({url: url, data: {}, access_token: auth.data.access_token, header: true})
                .then(response => {
                    //parseamos para agrupar
                    let keys = Object.keys(response.data.data.response)
                    if (keys.length > 0) {
                        let arrayParseadoDateInit = response.data.data.response[keys[0]].map(e => {
                            return {
                                dateTimeInit: moment(e.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DDTHH:mm:ss"),
                                doctors: e.doctors,
                                hour: e.hour
                            }
                        })
                        let arrGroupBy = groupBy(arrayParseadoDateInit, "dateTimeInit");
                        setGroupBySchedules(arrGroupBy)
                        let obj = {
                            key: keys[0],
                            value: Object.keys(arrGroupBy)
                        }
                        //console.log(obj)
                        setHorario(obj)
                    } else {
                        let obj = {
                            key: fecha,
                            value: []
                        }
                        setHorario(obj)
                    }
                    setLoadingHorarios(false)
                })
                .catch(error => {
                    setShowModalServer(true)
                    if (error.response) {
                        setErrorServer(error.response)
                    }
                    setLoadingHorarios(false)
                })
        }
    }, [fecha, especialidad])

    //efect para sucursales
    useEffect(() => {
        //efecto de sucursal
        Get({url: GET_SUCURSALES, access_token: auth.data.access_token})
            .then(response => {
                setSucursalesOpt(response.data.data.response)
            })
            .catch(error => {
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
    }, [])

    // Check expediente duplication (only for Colombia)
    useEffect(() => {
        // Only check for Colombia accounts
        if (company !== "colombia") {
            setExpedienteDuplicado(false)
            return
        }

        // Don't check if expediente is empty
        if (!expediente || expediente.trim() === '') {
            setExpedienteDuplicado(false)
            return
        }

        // Debounce: Wait 500ms after user stops typing
        const timeoutId = setTimeout(() => {
            setCheckingExpediente(true)
            Get({
                url: `${CHECK_EXPEDIENTE_DUPLICADO}/${expediente.trim()}`,
                access_token: auth.data.access_token
            })
            .then(response => {
                setCheckingExpediente(false)
                // API returns { expediente: "9768235", existe: false }
                // existe: true means it exists (duplicated), existe: false means not duplicated
                const isDuplicated = response.data.existe === true || response.data.data?.existe === true
                setExpedienteDuplicado(isDuplicated)
                if (isDuplicated) {
                    setShowModalExpedienteDuplicado(true)
                }
            })
            .catch(error => {
                setCheckingExpediente(false)
                // On error, allow submission (don't block user)
                setExpedienteDuplicado(false)
                console.error('Error checking expediente:', error)
            })
        }, 500) // 500ms debounce

        return () => clearTimeout(timeoutId)
    }, [expediente, company, auth.data.access_token])

    //efect para el checkbox modalidad
    // useEffect(() => {
    //     const fetchModalidades = async () => {
    //         if (!doctor) return;
    //
    //         console.log('doctor: ' + company)
    //
    //         try {
    //             const response = await fetch(`${URL_API}/api/doctor/${doctor.value}/modalidades`, {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     "Authorization": `Bearer ${auth.data.access_token}`,
    //                     "Accept": "application/json",
    //                 }
    //             });
    //             const data = await response.json();
    //             setModalidades(data);
    //
    //             if (data.length > 0) {
    //                 setSelectedModalidades(data[0].value);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching modalidades:', error);
    //             setModalidades([]);
    //         }
    //     };
    //
    //     fetchModalidades();
    // }, [doctor, auth.data.access_token]);

    const selectTime = (it, index) => {
        //console.log(index)
        setIndexSelectHor(index)
        setDoctor(null)
        serShowDoctor(true)
        try {
            let arrD = []
            arrGroupBySchedules[it].forEach(el => {
                let aux = el.doctors.map(e => ({
                    label: `${e.name} ${e.lastName} - ${e.provider}`,
                    value: e.id,
                    horario: it
                }))
                arrD.push(...aux)
            })
            setDoctoresOptDef(arrD)
        } catch (error) {
            setDoctoresOptDef([])
        }
    }

    const onHandleChangeDoctor = value => {
        setDoctor(value)
        //console.log(value)  
        let schedule = {
            scheduleType: "Online",
            doctor: {
                id: value.value
            },
            hourInit: moment(value.horario, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
        }
        setSchedule(schedule)
        // setSelectedModalidades('')
    }

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => setShowSuccess(false);

    const handleCrearCita = e => {
        let error = true
        let error2 = true
        if (patient === null || doctor === null) {
            setError(true)
        } else {
            error = false
            setError(false)
        }
        if (!peso || !talla || !sintomas || (company === "colombia" && !expediente) || (company === "colombia" && expedienteDuplicado) || (isConsultorio(auth.data.role) && company === 'mexico' && !sucursal)) {
            setErrorPesos(true)
            // Show modal if expediente is duplicated
            if (company === "colombia" && expedienteDuplicado) {
                setShowModalExpedienteDuplicado(true)
            }
        } else {
            error2 = false
            setErrorPesos(false)
        }

        if (!error && !error2) {
            handleShow()
        }
    }

    const shemaValidateChoice = Yup.object().shape({
        choiceType: Yup.string()
            .required(t('Camporequerido')),
    });

    const onClickConfirmar = e => {
        setLoadingAddCita(true)
        let d = {
            source: source,
            branchOffice: sucursal ? {id: sucursal} : null,
            appointmentStatus: (patient.account && validAutomatic) ? "Pagada" : "Pendiente",
            patient: {
                id: patient.id,
                email: patient.email
            },
            schedule: schedule,
            especialty: {
                id: especialidad.value
            },
            peso: peso ? parseInt(peso) : '',
            talla: talla ? parseInt(talla) : '',
            motivoConsulta: sintomas,
            expediente: expediente,
            account: patient.account,
            // modalidad_id: Number(selectedModalidades)
        }
        //console.log(d)
        Post({url: ADD_APPOINTMENT, data: d, access_token: auth.data.access_token, header: true})
            .then(response => {
                setLoadingAddCita(false)
                setShow(false)
                setShowSuccess(true)
                if (patient.account) {
                    setTimeout(() => {
                        setShowSuccess(false)
                        if (isDoctor(auth.data.role) || isConsultorio(auth.data.role)) {
                            history.replace(`/admin/doctors/patients`)
                        } else {
                            history.replace(`/admin/patients`)
                        }

                    }, 2000);
                } else {
                    setTimeout(() => {
                        setShowSuccess(false)
                        history.replace(`/admin/pagarservicio/${response.data.id}`)
                    }, 2000);
                }
            })
            .catch(error => {
                //console.log(error)
                setLoadingAddCita(false)
                setShowModalServer(true)
                setErrorServer(error?.response)
            })
    }

    const plusDay = n => {
        let nDays = startDay + n
        setStartDay(nDays)
        let newFecha = moment(fecha)
        newFecha.add(n, 'days')
        setFecha(newFecha)
    }
    const minusDay = n => {
        let nDays = startDay - n
        setStartDay(nDays)
        let newFecha = moment(fecha)
        newFecha.subtract(n, 'days')
        setFecha(newFecha)
    }

    return (
        <>
            <Container fluid className="my-5">
                <Row className="align-items-center">
                    <Col xs="12" md="8">
                        <h2 className="mb-0 title-top">{t('agregar_cita')}</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card className="shadow-1 my-4">
                            <Card.Body>
                                <Row className="mb-4">
                                    <Col>
                                        <div className="d-flex justify-content-between">
                                            <div><h4>{t('paciente_informacion')}</h4></div>
                                            {
                                                patient &&
                                                <div>
                                                    <Link
                                                        to={`${isDoctor(auth.data.role) ? `/admin/doctor/patient/${patient.id}` : `/admin/patients/create?id=${patient.id}`}`}
                                                        className="no-underline">
                                                        <h3 className="color-green">
                                                            <MdEdit className="mb-1 font-size-13rem"/> {t('editar')}
                                                        </h3>
                                                    </Link>
                                                </div>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('nombre_completo')}: </strong> {patient && `${patient.name} ${patient.middleName ?? ''} ${patient.lastName} ${patient.seccondSurname}`}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('sexo')}: </strong> {patient && (patient.gender === 'Male' ? t('Masculino') : t('Femenino'))}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Nacionalidad')}: </strong> {patient && patient.nationality}
                                        </label>
                                    </Col>
                                    {company === "mexico" &&
                                        <Col xs="12" md="4">
                                            <label><strong>{t('Estadocivil')}: </strong> {(patient && patient.maritalStatus) && patient.maritalStatus.name}
                                            </label>
                                        </Col>
                                    }
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Lugarnacimiento')}: </strong> {(patient && patient.countryBirth) && patient.countryBirth.name}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Telefono')}: </strong> {patient && patient.phoneNumber}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Correoelectronico')}: </strong> {patient && patient.email}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Religion')}: </strong> {(patient && patient.religion) && patient.religion.name}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Tiposangre')}: </strong> {patient && patient.bloodType}
                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('ocupacion')}: </strong>
                                            {
                                                (patient && company === "mexico") ?
                                                    `${patient?.occupation ?? ''}` :
                                                    `${patient?.ocupacion?.nombreOcupacion ?? ''}`
                                            }

                                        </label>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label><strong>{t('Idioma')}: </strong> {(patient && patient.language) && patient.language.name}
                                        </label>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <Row>
                                    {company === "colombia" && <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label>No. expediente</Form.Label>
                                            <Form.Control
                                                className={`input-form ${expedienteDuplicado ? 'is-invalid' : ''}`}
                                                type="text"
                                                value={expediente}
                                                onChange={e => setExpediente(e.target.value)}
                                                disabled={checkingExpediente}
                                            />
                                            {checkingExpediente && (
                                                <Form.Text className="text-muted">
                                                    Verificando expediente...
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>}
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label>Peso (Kg)</Form.Label>
                                            <Form.Control
                                                className="input-form"
                                                type="number"
                                                value={peso}
                                                onChange={e => setPeso(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label>Talla (cm)</Form.Label>
                                            <Form.Control
                                                className="input-form"
                                                type="number"
                                                value={talla}
                                                onChange={e => setTalla(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {(isConsultorio(auth.data.role) && company === "mexico") &&
                                        <Col xs="12" md="4">
                                            <Form.Group>
                                                <Form.Label>Sucursal</Form.Label>
                                                <Form.Control
                                                    className="input-form"
                                                    as="select"
                                                    value={sucursal}
                                                    onChange={e => setSucursal(e.target.value)}
                                                >
                                                    <option value="">Seleccionar</option>
                                                    {
                                                        sucursalesOpt.map((suc, index) => (
                                                            <option key={index} value={suc.id}>{suc.name}</option>
                                                        ))
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    }
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label>Motivo de la consulta</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows="3"
                                                className="input-form"
                                                value={sintomas}
                                                onChange={e => setSintomas(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {
                                    errorPesos &&
                                    <Row>
                                        <Col>
                                            <Alert variant="danger">Todos los campos son obligatorios</Alert>
                                        </Col>
                                    </Row>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {/*{error && <Row>*/}
                {/*    <Col>*/}
                {/*        <Alert variant="danger">*/}
                {/*            {company === 'colombia'*/}
                {/*                ? t('texto_agendar_cita_campos_modalidad')*/}
                {/*                : t('texto_agendar_cita_campos')*/}
                {/*            }*/}
                {/*        </Alert>*/}
                {/*    </Col>*/}
                {/*</Row>}*/}
                <Row className="mb-2">
                    <Col xs="12" md="6">
                        <Card>
                            <Card.Body>
                                <Row className="mb-4">
                                    <Col>
                                        <h4>{t('informacion_cita')}</h4>
                                    </Col>
                                </Row>
                                <Row className="mb-5">
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label
                                                className="font-weight-bold-600 text-secondary">{t('especialidad')}</Form.Label>
                                            <SelectAjax
                                                defaultValue={especialidad === null || Object.keys(especialidad).length === 0 ? false : especialidad}
                                                url={`${ESPECIALITIES_ALL_BY_ACCOUNT}/${patient?.account?.id}`}
                                                access_token={auth.data.access_token}
                                                isMulti={false}
                                                handleChange={(value) => setEspecialidad(value)}
                                                defaultOptions={specialityOpt}
                                                valid={true}
                                                isClearable={false}
                                                className='input-appointment'
                                            />
                                        </Form.Group>
                                    </Col>
                                    {
                                        showDoctor &&
                                        <Col xs="12" md="12">
                                            <Form.Group>
                                                <Form.Label
                                                    className="font-weight-bold-600 text-secondary">{t('doctor')}</Form.Label>
                                                <Select
                                                    className="input-appointment"
                                                    defaultValue={{}}
                                                    options={doctoresOptDef}
                                                    value={doctor}
                                                    onChange={(value) => onHandleChangeDoctor(value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    }
                                    {
                                        doctor &&
                                        <Col xs="12" md="12">
                                            <Form.Group>
                                                <Form.Label
                                                    className="font-weight-bold-600 text-secondary">{t('hora_asignada')}</Form.Label>
                                                <div className="div-form-control">
                                                    <Image fluid src={iconCalendar}
                                                           className="mr-4 mb-1 h-20"/> {moment(doctor?.horario, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")}
                                                </div>
                                            </Form.Group>
                                            {/*MODALIDAD*/}
                                            {/*{company === 'colombia' && (*/}
                                            {/*    <Form.Group>*/}
                                            {/*        <Form.Label*/}
                                            {/*            className="font-weight-bold-600 text-secondary">Modalidades</Form.Label>*/}
                                            {/*        {modalidades && modalidades.length > 0 ? (*/}
                                            {/*            modalidades.map((modalidad) => (*/}
                                            {/*                <Form.Check*/}
                                            {/*                    key={modalidad.value}*/}
                                            {/*                    type="radio"*/}
                                            {/*                    name="modalidades"*/}
                                            {/*                    id={`modalidad-${modalidad.value}`}*/}
                                            {/*                    label={`${modalidad.shortLabel} - ${modalidad.label}`}*/}
                                            {/*                    value={modalidad.value}*/}
                                            {/*                    checked={selectedModalidades === modalidad.value}*/}
                                            {/*                    onChange={(e) => setSelectedModalidades(modalidad.value)}*/}
                                            {/*                />*/}
                                            {/*            ))*/}
                                            {/*        ) : (*/}
                                            {/*            <Form.Text className="text-muted">No hay modalidades*/}
                                            {/*                disponibles</Form.Text>*/}
                                            {/*        )}*/}
                                            {/*    </Form.Group>*/}
                                            {/*)}*/}
                                        </Col>
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="12" md="6">
                        <Card>
                            <Card.Body>
                                <Row className="mb-4">
                                    <Col>
                                        <h4>{t('asignar_fecha_hora')}</h4>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="position-relative overflow-hidden">
                                        {loadingHorarios && <SimpleLoad/>}
                                        {
                                            !horario ?
                                                <Jumbotron>
                                                    <Container>
                                                        <p className="text-center">{t('no_informacion_disponible')}</p>
                                                    </Container>
                                                </Jumbotron> :
                                                <div>
                                                    <CardHorarioDoctorManual
                                                        horario={horario}
                                                        selectTime={selectTime}
                                                        indexSelect={indexSelectHor}
                                                        days={days}
                                                        plusDay={plusDay}
                                                        minusDay={minusDay}
                                                        startDay={startDay}
                                                    />
                                                </div>
                                        }
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-right">
                        <Link
                            to={(isDoctor(auth.data.role) || isConsultorio(auth.data.role)) ? "/admin/doctors/patients" : "/admin/patients"}
                            className="btn btn-danger cancelar-buttom">{t('cancelar')}</Link>{' '}
                        <Button 
                            variant="outline-success" 
                            className="ok-buttom" 
                            type="buttom" 
                            onClick={handleCrearCita}
                            disabled={company === "colombia" && expedienteDuplicado}
                        >
                            {t('crear')}
                        </Button>{' '}
                    </Col>
                </Row>
            </Container>

            <Modal show={show} onHide={handleClose} size="lg" backdrop="static" keyboard={false}>
                <Modal.Body className="overflow-hidden">
                    {loadingAddCita && <SimpleLoad/>}

                    <h5 className="mb-4 color-blue-dark">{t('confirmacion_colicitud')}</h5>
                    <p className="font-size-09rem color-6A6A">{t('creara_cita_info')}:</p>

                    {patient && <div><label
                        className="font-size-09rem"><strong>{t('nombre_completo')}: </strong>{`${patient.name} ${patient.middleName ?? ''} ${patient.lastName} ${patient.seccondSurname ?? ''}`}
                    </label></div>}
                    {patient && <div><label
                        className="font-size-09rem"><strong>{t('Correoelectronico')}: </strong>{patient.email}</label>
                    </div>}
                    {patient &&
                        <div><label className="font-size-09rem"><strong>{t('Telefono')}: </strong>{patient.phoneNumber}
                        </label></div>}

                    <h5 className="my-4 color-blue-dark">{t('cita')}</h5>
                    <div><label
                        className="font-size-09rem"><strong>{t('fecha')}: </strong>{moment(doctor?.horario, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY, HH:mm")} hrs</label>
                    </div>
                    {doctor &&
                        <div><label className="font-size-09rem"><strong>{t('doctor')}: </strong>{doctor.label}</label>
                        </div>}
                    {doctor && <div><label
                        className="font-size-09rem"><strong>{t('especialidad')}: </strong>{especialidad.label}</label>
                    </div>}

                    <div className="my-4 text-right">

                        {
                            company === "colombia" ?
                                <Formik
                                    initialValues={{choiceType: ''}}
                                    validationSchema={shemaValidateChoice}
                                    onSubmit={(values) => {
                                        // Prevent submission if expediente is duplicated
                                        if (expedienteDuplicado) {
                                            setShowModalExpedienteDuplicado(true)
                                            return
                                        }
                                        setLoadingAddCita(true)
                                        let d = {
                                            appointmentStatus: "Pagada",
                                            patient: {
                                                id: patient.id,
                                                email: patient.email
                                            },
                                            schedule: {
                                                scheduleType: "Online",
                                                doctor: {
                                                    id: doctor.value
                                                },
                                                hourInit: moment(doctor.horario, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
                                            },
                                            especialty: {
                                                id: especialidad.value
                                            },
                                            peso: peso ? parseInt(peso) : '',
                                            talla: talla ? parseInt(talla) : '',
                                            motivoConsulta: sintomas,
                                            expediente: expediente,
                                            choiceType: values.choiceType,
                                            // modalidad_id: Number(selectedModalidades),
                                            legalWarnings: [{
                                                id: null,
                                                acceptPatient: "pending",
                                                legalWarningType: "InformedConsent"
                                            }]
                                        }
                                        //console.log(d)
                                        Post({
                                            url: ADD_APPOINTMENT,
                                            data: d,
                                            access_token: auth.data.access_token,
                                            header: true
                                        })
                                            .then(response => {
                                                setLoadingAddCita(false)
                                                setShow(false)
                                                setShowSuccess(true)
                                                if (patient.account) {
                                                    setTimeout(() => {
                                                        if (isConsultorio(auth.data.role) || isDoctor(auth.data.role)) {
                                                            history.replace(`/admin/doctors/patients`)
                                                        } else {
                                                            history.replace(`/admin/patients`)
                                                        }
                                                    }, 2000);
                                                } else {
                                                    history.replace(`/admin/pagarservicio/${response.data.id}`)

                                                }
                                            })
                                            .catch(error => {
                                                //console.log(error)
                                                setLoadingAddCita(false)
                                                setShowModalServer(true)
                                                setErrorServer(error?.response)
                                            })
                                    }}
                                >{({
                                       errors,
                                       handleSubmit,
                                       setFieldValue,
                                       setFieldError
                                   }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <div>
                                            <label className="d-block font-weight-bold mr-5">La selección de esta fecha
                                            y hora de consulta se debió a:</label>
                                            <label
                                                className={`mr-5 text-color-input d-block ${errors.choiceType ? 'color-red' : ''}`}>
                                                Era la consulta disponible más cercana
                                                <Field
                                                    type="radio"
                                                    name="choiceType"
                                                    value="closerAppointment"
                                                    className="ml-3 radio-form"
                                                />
                                            </label>
                                            <label
                                                className={`mr-5 text-color-input ${errors.choiceType ? 'color-red' : ''}`}>
                                                Era la que mejor se adaptaba a mi disponibilidad y preferencia
                                                <Field
                                                    type="radio"
                                                    name="choiceType"
                                                    value="preferAppointment"
                                                    className="ml-3 radio-form"
                                                />
                                            </label>
                                            {errors.choiceType &&
                                                <div className="invalid-feedback d-block">{errors.choiceType}</div>}
                                        </div>
                                        <div className="mt-4">
                                            <Button variant="link" className="text-danger font-weight-bold"
                                                    onClick={handleClose}>{t('regresar')}</Button>
                                            <Button 
                                                type="submit" 
                                                variant="primary"
                                                disabled={expedienteDuplicado}
                                            >
                                                {t('confirmar')}
                                            </Button>
                                        </div>

                                    </Form>
                                )}
                                </Formik> :
                                <div>
                                    <Button variant="link" className="text-danger font-weight-bold"
                                            onClick={handleClose}>{t('regresar')}</Button>
                                    <Button 
                                        variant="outline-success" 
                                        className="ok-buttom" 
                                        onClick={onClickConfirmar}
                                        disabled={company === "colombia" && expedienteDuplicado}
                                    >
                                        {
                                            (patient && patient.account) ? t('confirmar') : t('pagar')

                                        }
                                    </Button>
                                </div>
                        }
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                <Modal.Body className="p-0">
                    <div className="text-center position-relative overflow-hidden h-100p">
                        <Image src={iconRecheck} fluid className="img-recheck"/>
                        <h5 className="mb-0 text-app-success">{t('solicitud_exitosa')}</h5>
                    </div>
                </Modal.Body>
            </Modal>
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
            {/* Modal for expediente duplicado (only for Colombia) */}
            <Modal 
                show={showModalExpedienteDuplicado} 
                onHide={() => setShowModalExpedienteDuplicado(false)} 
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="danger" className="mb-0">
                        El expediente esta duplicado
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalExpedienteDuplicado(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default withTranslation()(CreateAppointment)